var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modify-apply-block',{ref:"worker_job_title_p",attrs:{"data-type":"worker_job_title","getEdit":_vm.getEdit,"saveEdit":_vm.saveEdit,"addEdit":_vm.addEdit,"form-parms-add":_vm.formParmsAdd,"block-name":"岗位信息","getTitle":_vm.getTitle,"deal-data-info":_vm.dealDataInfo,"ref-name":"worker_job_title","worker-id":_vm.workerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }